module.exports = __webpack_public_path__ + "src/assets/games/39/EGGS0040.jpg";